import {Component, computed, inject, Input, TemplateRef } from '@angular/core';
import {LayoutService} from '@/theme/service/layout.service';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: '[app-footer]',
    standalone: true,
    imports: [
        NgTemplateOutlet
    ],
    template: `
        <div class="layout-footer">
            <div class="footer-logo-container">
                @if (footerLogoTemplate) {
                    <ng-container *ngTemplateOutlet="footerLogoTemplate"></ng-container>
                }
                @else {
                    <img src="/theme/images/logo-{{ isDarkTheme() ? 'white' : 'dark' }}.svg" alt="diamond-layout"/>
                    <span class="footer-app-name">DIAMOND</span>
                }
            </div>
            <span class="footer-copyright">{{ footerCopyright }}</span>
        </div>
    `
})
export class AppFooter {
    @Input({ required: true }) footerCopyright!: string;
    @Input({ required: false }) footerLogoTemplate?: TemplateRef<any>;

    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
